import type { Ref } from 'vue';
import {
  computed,
} from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getDashboardAdminTranslations(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      dashboard: {
        stats_block: {
          registration_count: 'STATS_REGISTRATION_COUNT',
          first_deposit_count: 'STATS_FIRST_DEPOSIT_COUNT',
          ngr: 'STATS_NGR',
          profit: 'STATS_PROFIT',
          deposits: 'STATS_DEPOSITS',
          withdrawals: 'STATS_WITHDRAWALS',
        },
        top_partners: {
          header: 'TOP_PARTNERS_HEADER',
        },
        top_trackers: {
          header: 'TOP_TRACKERS_HEADER',
        },
        top_players: {
          header: 'TOP_PLAYERS_HEADER',
        },
        periods: {
          today: 'PERIODS_TODAY',
          yesterday: 'PERIODS_YESTERDAY',
          last_week: 'PERIODS_LAST_WEEK',
          week: 'PERIODS_WEEK',
          month: 'PERIODS_MONTH',
          last_month: 'PERIODS_LAST_MONTH',
          year: 'PERIODS_YEAR',
        },
        charts: {
          by_day: {
            header: 'CHARTS_BY_DAY_HEADER',
            month: 'CHARTS_BY_DAY_MONTH',
            last_month: 'CHARTS_BY_DAY_LAST_MONTH',
          },
          by_months: {
            header: 'CHARTS_BY_MONTH_HEADER',
            old_players: 'CHARTS_BY_MONTH_OLD_PLAYERS',
            new_players: 'CHARTS_BY_MONTH_NEW_PLAYERS',
          },
        },
        last_update: 'LAST_UPDATE',
        button_reports: 'BUTTON_REPORTS',
      },
    },
  }));
}

export function getDashboardAffiliateTranslations(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      dashboard: {
        last_update: 'LAST_UPDATE',
        periods: {
          today: 'PERIODS_TODAY',
          yesterday: 'PERIODS_YESTERDAY',
          last_week: 'PERIODS_LAST_WEEK',
          week: 'PERIODS_WEEK',
          month: 'PERIODS_MONTH',
          last_month: 'PERIODS_LAST_MONTH',
          year: 'PERIODS_YEAR',
        },
        stats_block: {
          header: 'STATS_HEADER',
          views_count: 'STATS_VIEWS_COUNT',
          clicks_count: 'STATS_CLICKS_COUNT',
          partner_commission: 'STATS_PROFIT',
          number_of_registrations: 'STATS_REGISTRATION_COUNT',
          number_of_depositaries: 'STATS_CLIENT_COUNT',
          fixed_payment: 'STATS_FIXED_PAYMENT',
        },
        manager_block: {
          header: 'MANAGER_HEADER',
          name: 'MANAGER_NAME',
          ms_teams: 'MANAGER_MS_TEAMS',
          telegram: 'MANAGER_TELEGRAM',
          whatsapp: 'MANAGER_WHATSAPP',
          email: 'MANAGER_EMAIL',
        },
        checking_player: {
          header: 'CHECK_PLAYER_HEADER',
          players_name: 'CHECK_PLAYER_PLAYERS_NAME',
          check_button: 'CHECK_PLAYER_BUTTON',
          placeholder: 'CHECK_PLAYER_PLACEHOLDER',
          modal_window: {
            title: 'CHECK_PLAYER_MODAL_TITLE',
          },
        },
        charts: {
          by_day: {
            header: 'CHARTS_BY_DAY_HEADER',
            month: 'CHARTS_BY_DAY_MONTH',
            last_month: 'CHARTS_BY_DAY_LAST_MONTH',
          },
          by_months: {
            header: 'CHARTS_BY_MONTH_HEADER',
            old_players: 'CHARTS_BY_MONTH_OLD_PLAYERS',
            new_players: 'CHARTS_BY_MONTH_NEW_PLAYERS',
          },
        },
        last_articles: {
          title: 'LAST_ARTICLES_TITLE',
          no_articles: 'LAST_ARTICLES_NO_ARTICLES',
          see_more: 'LAST_ARTICLES_SEE_MORE',
        },
      },
    },
  }));
}
